var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.2155 3.32534L0.885797 5.6233C0.8125 5.66185 0.74218 5.70582 0.675422 5.75483L11.7469 11.5281L16.383 9.23497L5.2155 3.32534ZM23.9978 7.03691L18.459 9.77647V12.8629C18.459 13.251 18.1442 13.5658 17.7561 13.5658C17.3679 13.5658 17.0532 13.251 17.0532 12.8629V10.4718L12.4413 12.7529V23.923C12.4558 23.9163 12.4704 23.9101 12.4847 23.903L23.087 18.5308C23.6502 18.2492 24 17.6833 24 17.0534V7.09902C24 7.07816 23.9986 7.05758 23.9978 7.03691ZM23.087 5.62152L12.489 0.251657L12.4846 0.249454C12.0127 0.0145164 11.452 0.0197664 10.9845 0.263516L6.71602 2.52894L17.9365 8.46655L23.3524 5.78778C23.2693 5.72416 23.1805 5.66849 23.087 5.62152ZM0.00332812 6.9898C0.00127696 7.02209 0.000167112 7.05443 0 7.08678L0 17.0656C0 17.6825 0.339375 18.243 0.88575 18.5291L10.98 23.8865L10.9846 23.8889C11.0014 23.8977 11.0185 23.9054 11.0355 23.9135V12.7426L0.00332812 6.9898Z",
      "fill": "currentColor"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }